import { Outlet } from "react-router-dom";
import styles from "./Layout.module.css";
import CaritasLogo from "../../assets/caritas_logo.svg";
import { Stack } from "@fluentui/react";
import { useContext } from "react";
import { AppStateContext } from "../../state/AppProvider";
import { useTexts } from "../../context/TextProvider";
import { HtmlContent } from "../../components/HtmlContent";

const Layout = () => {
    const appStateContext = useContext(AppStateContext);
    const { texts } = useTexts();
    const hasMessages = (appStateContext?.state?.currentChat?.messages?.length ?? 0) > 0;
    const consentGiven = appStateContext?.state?.consentGiven ?? false;

    const openUsageDisclaimer = () => {
        appStateContext?.dispatch({
            type: "UPDATE_SHOW_USAGE_DISCLAIMER",
            payload: true,
        });
    };

    return (
        <div className={styles.layout}>
            <header className={styles.header} role={"banner"}>
                <Stack
                    horizontal
                    verticalAlign="start"
                    horizontalAlign="space-between"
                >
                    <a href="https://www.das-steht-dir-zu.de/start" target="_blank" rel="noreferrer" aria-label="Caritas – Das steht dir zu (öffnet in neuem Tab)">
                        <img
                            src={CaritasLogo}
                            className={styles.headerIcon}
                            aria-hidden="true"
                            alt=""
                        />
                    </a>
                    <div className={styles.headerWelcome}>
                        {hasMessages ? (
                            texts?.texts.general.headerMessage ? (
                                <HtmlContent html={texts.texts.general.headerMessage} />
                            ) : (
                                <HtmlContent html="<strong>Caritas-Chatbot</strong><br/>zur Grundsicherung." />
                            )
                        ) : (
                            texts?.texts.general.headerMessageWelcome ? (
                                <HtmlContent html={texts.texts.general.headerMessageWelcome} />
                            ) : (
                                <HtmlContent html="Willkommen beim <strong>Caritas-Chatbot</strong> zur Grundsicherung." />
                            )
                        )}
                    </div>
                </Stack>
            </header>
            {/* )} */}
            <Outlet />
            <div className={`${styles.footerWrapper}${consentGiven ? ` ${styles.footerWrapperVisible}` : ""}`}>
                <Stack
                    horizontal
                    verticalAlign="center"
                    horizontalAlign="center"
                    className={`${styles.footer}${hasMessages ? ` ${styles.footerTransparent}` : ""}`}
                >
                    Der Caritas-Chatbot kann Fehler machen{" "}
                    &middot;
                    <a href="#" onClick={() => openUsageDisclaimer()} className={styles.disclaimerBtn}>
                        {texts?.texts.navigation.usageConsent ?? "Nutzungsbedingungen"}
                    </a>{" "}
                    &middot;
                    <a href={texts?.texts.navigation.dataPrivacyUrl ?? "http://www.das-steht-dir-zu.de/impressum/datenschutz"} target="_blank" rel="noopener noreferrer">
                        {texts?.texts.navigation.dataPrivacy ?? "Datenschutz"}
                    </a>{" "}
                    &middot;
                    <a href={texts?.texts.navigation.legalNoticeUrl ?? "http://www.das-steht-dir-zu.de/impressum"} target="_blank" rel="noopener noreferrer">
                        {texts?.texts.navigation.legalNotice ?? "Impressum"}
                    </a>
                </Stack>
            </div>
        </div>
    );
};

export default Layout;
